import { SERVICE_OGP_IMAGE, SITE_URL } from '../constants'
import { PageMeta } from '../types'

export const securityPrivacyPageMeta: PageMeta = {
  title: '情報セキュリティ方針・個人情報保護方針 | Aitria（アイトリア）',
  description:
    'Aitria（アイトリア）の情報セキュリティ方針と個人情報保護方針についてご案内します。',
  keyword: '情報セキュリティ方針 プライバシーポリシー 個人情報保護方針',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/security-privacy/`,
}
